import React, { useContext, useEffect, useRef, useState } from 'react'

import Message from '../message/Message'
import Send from '../send/Send'
import { AuthContext } from '../../context/AuthContext'
import { MessengerContext } from '../../context/MessengerContext'

import './chatBox.css'
import EmptyStateConversation from '../emptyStateConversation/EmptyStateConversation'
import MessengerWelcome from '../messengerWelcome/MessengerWelcome'

const ChatBox = ({socket}) => {

  const [messages, setMessages] = useState([])
  const [arrivalMessage, setArrivalMessage] = useState(null)
  const [communicator, setCommunicator] = useState([])
  const [conversation, setConversation] = useContext(MessengerContext)
  const scrollRef = useRef()
  const {user: currentUser} = useContext(AuthContext)

  useEffect(() => {
    setCommunicator(conversation.communicator)
    setMessages(conversation.messages)
  }, [conversation])

  useEffect(() => {
    scrollRef.current?.scrollIntoView({behavior: "smooth"})
  }, [messages, conversation])

  useEffect(() => {
    socket.current?.on("getMessage", (data) => {
      setArrivalMessage({
        sender: data.senderId,
        text: data.text,
        createdAt: new Date().toUTCString()
      })
    })
  }, [socket.current])

  useEffect(() => {
    arrivalMessage && conversation.conversation.members.includes(arrivalMessage.sender) 
    && setConversation((oldConversation) => ({
        ...oldConversation,
        messages: [
          ...oldConversation.messages,
          arrivalMessage
        ]
      }))
  }, [arrivalMessage])

  return (
    <div className="chatBox">
        <div className="chatBoxWrapper">
            <div className="chatBoxTop">
              {
                (Object.keys(conversation.communicator).length !== 0
                ?
                  <>
                    <EmptyStateConversation />
                    {messages.map((message) => (
                      <div key={message._id} ref={scrollRef}>
                        <Message communicator={communicator} sender={message.sender !== currentUser._id ? "other" : "me"} text={message.text} sendingTime={message.createdAt}/>
                      </div>
                    ))}
                  </>
                :
                <MessengerWelcome />)
              }
            </div>
            <div className="chatBoxBottom">
              {
                Object.keys(conversation.communicator).length !== 0 &&
                <Send sendMessage={(newMessage) => {setMessages((oldMessages) => [...oldMessages, newMessage])}} socket={socket}/>
              }
            </div>
        </div>
    </div>
  )
}

export default ChatBox